<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <div class="certify-masker" v-if="!user.certified && !['/productMarket', '/productMarket/detail'].includes($route.path)" @click="toVerify"></div>
    <AIToolBar  v-if="appCode.includes('YY00108') && AIApp && AIApp.linkUrl" :aiApp="AIApp" />
    <ToolBar />
  </section>
</template>

<script>
import helpCenter from '@/views/helpCenter'
import Memorandum from '@/components/Memorandum'
import { mapGetters } from 'vuex';
import { generateLink } from '@/api/login'
import ToolBar from './ToolBar'
import AIToolBar from './AIToolBar'

export default {
  name: 'AppMain',
  components: { helpCenter, Memorandum, ToolBar, AIToolBar },
  data() {
    return {
      AIApp:{
        linkUrl: null,
        icon: null,
      },
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    ...mapGetters(['verifyInfo', 'user', 'appCode']),

  },
  created() {
    this.getAIAppInfo('YY00108')
  },
  methods: {
    // 获取AI应用信息
    getAIAppInfo(appCode) {
      this.$store.dispatch('GetOpenAppInfo', {appCode}).then(res => {
        if (res) {
          const linkUrlObj = res.filter(item => item.attributeField === 'linkUrl')
          const iconFileObj = res.filter(item => item.attributeField === 'icon')
          let linkUrl = null
          if(linkUrlObj){
            linkUrl = linkUrlObj[0].attributeValue || null
          }
          let icon = null
          if(iconFileObj && iconFileObj[0].fileList){
            icon = iconFileObj[0].fileList[0].fileUrl || ''
          }
          this.AIApp.linkUrl = linkUrl
          this.AIApp.icon = icon
        }
      })
    },
    async toVerify() {
      console.log('this.user', this.user)
      let title = ''
      let message =`<span style="font-weight: bold;">${this.user.realName}</span> 您好！您尚未完成企业认证，没有权限进行该操作。<br>`
      let confirmButtonText = ''

      await this.$store.dispatch('GetVerifyInfo')

      if (!this.user.certified) {
        if (this.verifyInfo) {
          if (this.verifyInfo.isCertified == '0') {
            title = '企业认证'
            if (this.verifyInfo.auditStatus == '0') {
              message += '您提交的企业认证待审核中，请耐心等待。'
              confirmButtonText = '关闭'
            }
            else if (this.verifyInfo.auditStatus == '2') {
              message += '您提交的企业认证不通过，请重新提交认证。'
              confirmButtonText = '重新认证'
            }
          }
          else if (this.verifyInfo.auditStatus == '1') {
            title = '企业认证'
            message =`<span>${this.user.realName}</span> 您好！您已完成企业认证。请重新登录开始使用。<br>`
            confirmButtonText = '重新登录'
          }
        }
        else {
          title = '您未认证企业'
          message += ''
          confirmButtonText = '前往认证'
        }

      }

      this.$confirm(`<div style="text-align: center">${message}</div>`, title, {
        showConfirmButton: confirmButtonText,
        showCancelButton: !confirmButtonText,
        confirmButtonText,
        cancelButtonText: '关闭',
				dangerouslyUseHTMLString: true,
      }).then(() => {
        if (confirmButtonText == '重新登录') {
          this.reLogin()
        }
        else if (['前往认证', '重新认证'].includes(confirmButtonText)) {
          const params = {}
          if (this.verifyInfo && this.verifyInfo.id) {
            params.busId = this.verifyInfo.id
          }
          params.contacts = this.user.realName
          params.mobileNo = this.user.phone
          generateLink(params).then(res => {
            window.open(res.url)
          })
        }
      })
    },
    reLogin() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f9fafc;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
		height: auto;
		box-sizing: initial;
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}

.certify-masker {
  position: absolute;
  width: 100%;
  height: calc(100% - 84px);
  top: 84px;
  left: 0;
  z-index: 9;
}

</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
